import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";
import * as constants from "../../../../constants";
import toast from "react-hot-toast";
import { useState } from "react";
import { notifyUser } from "../../Utils/notifyUser";

const BASE_UPLOAD_URL = environment.postDocuments;
const DOWNLOAD_DOCS_BY_ID = environment.getDownloadDocumentsById;

interface UploadDocumentParams {
    doc: { id: number; documentName: string; path: File };  // ✅ include `id`
    entityType: string;
    entityId: number;
    clientId: number;
    fileTypePath: string; 
}

 

export const uploadDocument = async ({
    doc,
    entityType,
    entityId,
    clientId,
    fileTypePath, 
}: UploadDocumentParams) => {
    const formData = new FormData();
    const uploadParamData = {
        id: doc.id, // ✅ use dynamic ID
        entityType,
        entityId,
        clientId,
        documentName: doc.documentName,
        isActive: 'Y',
        version: 0,
    };

    formData.append('file', doc.path);
    formData.append(
        'documents',
        new Blob([JSON.stringify(uploadParamData)], {
            type: 'application/json',
        })
    );

    try {
        const response = await axiosInterceptor.post(
            `${BASE_UPLOAD_URL}${fileTypePath}/${entityId}/upload`, // dynamic URL
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }, 
            }
        ); 
        return response;
    } catch (error) { 
        throw error;
    }
};

export async function getDocumentsById(id: number, type:string,isActive:string) {
    
    let DocumentVo = {
        entityType: type,
        entityId:id,
        page: -1,
        size: -1,
        isActive: isActive,
      }; 
      try {
        const response = await axiosInterceptor.post(`${environment.getDocumentsById}`, DocumentVo);
        return response;
      } catch (error) {
        throw error;
      }
  }

  export async function downloadDocument(rowData: any,clientId:number) {
    
    const filePath = rowData?.documentPath;
    const baseToRemove = constants.SHAREPOINT_BASEURL;
    const updatedPath = filePath?.replace(baseToRemove, "");
    try {
      const response = await axiosInterceptor.get(
        `${ environment.downloadDocuments}${updatedPath}&clientId=${clientId}`
      );
      if (response.status === constants.STATUS_CODES.SUCCESS && response) {
        const base64Data = response.data.data.document;
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = rowData?.documentName; // Use the file name from the file object or a default name
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
       // setLoadingFlag(false);
        toast.success(`${rowData?.documentName} successfully downloaded`);
      } else {
      //  setLoadingFlag(false);

        toast.error(`${rowData?.documentName} failed to download file`);
      }
    } catch (error: any) {
     // setLoadingFlag(false);
      toast.error(error.response.data.message);
    }
  }


  export async function downloadDocumentByDocumentId(rowData: any, clientId: number) {
  try {
    const response = await axiosInterceptor.get(
      `${DOWNLOAD_DOCS_BY_ID}${rowData.id}?clientId=${clientId}`
    );
    if (response.status === constants.STATUS_CODES.SUCCESS && response) {
      const base64Data = response.data.data.document;
      const byteCharacters = atob(base64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = rowData?.documentName || "downloaded-file";
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
        notifyUser(`${rowData?.documentName} successfully downloaded`, "success", "Document Download" );  
    } else {
      notifyUser(`${rowData?.documentName} failed to download file`, "error", "Document Download" ); 
    }
  } catch (error: any) {
      notifyUser(error.response?.data?.message || "File download failed", "error", "Document Download" );  
  }
}